import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { requestTranslation } from "@futures-platform/i18n";
import { useDispatch } from "react-redux";
import { timerangePageHandler } from "../actions/radarSettings";

export default function CustomToast({ isShow, canEditRadar=false }) {
  const hasShownToast = useRef(false);
  const dispatch = useDispatch();

  const handleTimerangeClick = (e) => {
    e.preventDefault();
    dispatch(timerangePageHandler());
  };

  useEffect(() => {
    if (canEditRadar && !hasShownToast.current && isShow) {
      toast(
        <div>
          <p style={{ fontWeight: '600', marginBottom: '8px' }}>{requestTranslation('phenomena_beyond_sector_radar_main_title')}</p>
          <p style={{ marginBottom: '4px' }}>{requestTranslation('phenomena_beyond_sector_radar_main_description')} <a href="#" onClick={handleTimerangeClick} style={{ textDecoration: 'underline', color: '#121212' }}>{requestTranslation('phenomena_beyond_sector_radar_main_description_link')}</a>.</p>
        </div>,
        {
          autoClose: 60000,            // 1 minute
          position: "top-right",  
          className: "toast-phen-beyond-sector-radar",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          toastClassName: {
            // background: "#6FBF40",
            // color: "#FFFFFF",
            // fontWeight: "bold",
            // borderRadius: "6px",
          },
        }
      );

      hasShownToast.current = true;
    }

    if (!isShow) {
      hasShownToast.current = false; // allow showing again next time
    }
  }, [isShow, dispatch, canEditRadar, dispatch]);

  return null; // DO NOT render another ToastContainer here
}